import Alpine from 'alpinejs'
import { debounce } from './utils'

export const initCollapsible = (): void => {
    Alpine.data('collapsible', (minHeight = 0, expandedState = false, filters = null, parentFilter = '', animationOnInit = true) => ({
        contentHeight: minHeight ? minHeight : 0,
        active: expandedState,
        init() {
            if (animationOnInit) {
                this.$refs.content.classList.add('animate')
            }

            setTimeout(
                () => {
                    if (expandedState) {
                        this.contentHeight = this.$refs.content.scrollHeight
                        this.resizeParentCollapsible(parentFilter, this.contentHeight)
                    }

                    if (filters) {
                        const urlParams = new URLSearchParams(window.location.search)
                        const filterId = filters.split('.')
                        let lastFilterId = filterId[filterId.length - 1]
                        lastFilterId = lastFilterId.replace('_pct', '')
                        lastFilterId = lastFilterId.replace('price', 'prijs')

                        if (urlParams.has(lastFilterId) || urlParams.has(`${lastFilterId}[]`)) {
                            this.toggle()
                        }
                    }
                },
                parentFilter ? (animationOnInit ? 250 : 0) : (animationOnInit ? 600 : 100)
            )

            if (!animationOnInit) {
                setTimeout(
                    () => {
                        this.$refs.content.classList.add('animate')
                    }, 100)
            }

            window.addEventListener(
                'resize',
                debounce(() => this.updateContentHeight())
            )
        },
        toggle(_event = null, isFilterOpen = false, parentFilter = '') {
            if (!isFilterOpen) {
                this.active = !this.active
                this.contentHeight = this.active ? this.$refs.content.scrollHeight : minHeight
                this.resizeParentCollapsible(parentFilter, this.contentHeight)
            }
        },
        resizeParentCollapsible(parentFilter, contentHeight) {
            if (parentFilter) {
                window.dispatchEvent(new CustomEvent(`resize-collapsible-${parentFilter}`, { detail: { childContentHeight: contentHeight } }))
            }
        },
        updateContentHeight(childContentHeight = 0) {
            if (this.active) {
                this.contentHeight = this.$refs.content.scrollHeight + childContentHeight
            }
        },
    }))
}
